import { Box, Center, HStack, Image, Text } from "@chakra-ui/react";
import { OrderStatus } from "lib/api/enum";
import { OrderModel } from "lib/api/model";
import { digit } from "lib/utils/digit";
import { getOrderStatusString } from "../string/getString";

interface OrderCellProps {
    data: OrderModel;
}

const OrderCell = (props: OrderCellProps) => {
    const { data } = props;

    const getStatusColor = (status: OrderStatus) => {
        if (
            status === OrderStatus.CANCEL_ORDER ||
            status === OrderStatus.REJECT_ORDER
        )
            return "#ff375f";

        return "#128cfe";
    };

    return (
        <HStack display={"flex"} alignItems={"flex-start"}>
            <Center>
                <Image
                    src={data.image[0]}
                    w="4rem"
                    h="4rem"
                    border={"1px"}
                    borderColor="#eeeeee"
                    borderRadius={"md"}
                />
            </Center>
            <Box flex="1">
                <HStack justifyContent={"space-between"}>
                    <HStack>
                        <Text fontSize={"1rem"} fontWeight="semibold">
                            {`${data.category_name} / ${data.material_name} `}
                        </Text>
                        <Text
                            fontSize={"1rem"}
                            fontWeight="medium"
                            color="#151515"
                        >
                            외
                        </Text>
                        <Text fontSize={"1rem"} fontWeight="semibold">
                            {`총 ${data.item_count}건`}
                        </Text>
                    </HStack>
                    <Image
                        src="/assets/images/icn_list_arrow.svg"
                        w="1.375rem"
                        h="1.375rem"
                    />
                </HStack>
                <Text
                    fontSize={"0.875rem"}
                    fontWeight="medium"
                    color={getStatusColor(data.order_status)}
                >
                    {getOrderStatusString(
                        data.delivery_method,
                        data.order_status
                    )}
                </Text>
                <HStack justifyContent={"space-between"}>
                    <Text fontSize={"0.938rem"} fontWeight="bold">
                        {`${digit(data.payment_amount)} 원`}
                    </Text>
                    <Text
                        fontSize={"0.813rem"}
                        fontWeight="medium"
                        color="#757575"
                    >
                        {new Date(data.reg_date).toLocaleDateString()}
                    </Text>
                </HStack>
            </Box>
        </HStack>
    );
};

export default OrderCell;
